import React from "react";
import { imageUrl } from "lib";
import Loader from "components/loader";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useAgrid } from "agrid-js/react";

function Catalogue({ currentCatalogId }) {
  const catalogues = useSelector((state) => state.technicalProcess.listCatalogueTechnicalProcess);
  const agrid = useAgrid();

  return (
    <div className="cate-lst qtkt">
      <div className="row">
        <Loader isLoading={catalogues.isLoading} />
        {catalogues.data
          .filter((catalog) => catalog.id != currentCatalogId)
          .map(function (cat, index) {
            let data = {
              catName: cat.name,
            };
            let imageCatalogue = !cat.image ? "/images/product-image-default.png" : imageUrl(cat.image);
            return (
              <div className="col-md-3 col-sm-6 col-xs-12 mb-2" key={index}>
                <Link
                  className="cate-item position-relative"
                  title={cat.name}
                  to={`/quy-trinh-ky-thuat/danh-muc/${cat.slug || cat.id}`}
                  state={data}
                  // onClick={() =>
                  //   agrid?.capture("View Catalogue", {
                  //     catalogue_id: cat.id,
                  //     catalogue_name: cat.name,
                  //   })
                  // }
                >
                  <div className="img-box w-100 h-100 position-absolute">
                    <div className="wrap-img">
                      <img src={imageCatalogue} alt="product cate" title="product cate" className="img-cover" />
                    </div>
                  </div>

                  <div className="prod-inf position-absolute d-flex align-items-center">
                    <div className={`line-clamp-02 fw-semibold w-100 fs-6 `}>{cat.name}</div>
                  </div>
                </Link>
              </div>
            );
          })}
      </div>
    </div>
  );
}

export default Catalogue;
